/* eslint-disable */
export default {
  to: 'Para',
  enterNameOrNumber: 'Escribir nombre o número',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
